/**
 * 提交订单
 */
 import {request} from '@/assets/js/request.js'
 import {serverUrl} from '@/api/baseMap'
 
 export function getCodeChallenge() {
    return request({
      method: 'get',
      url: `${serverUrl}activity/v2/getCodeChallenge`,
    })
 }

 export function loginByCodeInapp(data) {
  return request({
      method: 'get',
      url: `${serverUrl}activity/v2/autoLoginAndRedirectYH?code=${data.code}&state=${data.state}`,
      data: {}
  })
}


// WEBPACK FOOTER //
// ./src/api/thirdLogin.js